export default "__VITE_ASSET__WJF0A0bX__"